import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { StylerAuthService } from './styler-auth.service';

export const stylerAuthInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith(environment.styler_api_url)) {
    return next(request);
  }

  return inject(StylerAuthService)
    .getToken()
    .pipe(
      switchMap((token) =>
        next(
          request.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          }),
        ),
      ),
    );
};
